import useModalStore from 'zustands/useAlertConfirmStore';
import useApi from './useApi';
import useUserStore from 'zustands/useUserStore';
import useStoreStore from 'zustands/useStoreStore';
import useLogout from './useLogout';
import { useLocation, useNavigate } from 'react-router-dom';

const useErrorLog = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { setModalState } = useModalStore();
  const { userToken } = useUserStore();
  const { storeSeq, setStoreInfo } = useStoreStore();

  const { commonErrorApi } = useApi();
  const logoutFn = useLogout();

  const checkErrorLog = async (err: Error | unknown, from: string) => {
    if (userToken === '') {
      logoutFn();
    } else if (storeSeq === '' && location.pathname !== '/business-establishment-choice') {
      setStoreInfo({ storeSeq: '', storeName: '', storeSeqNumber: 0 });
      navigate('/business-establishment-choice');
    } else {
      if (process.env.NODE_ENV === 'production') {
        setModalState({ isModalShow: true, title: '', desc: '통신이 월활하지 않습니다. 고객센터로 문의해 주세요.' });
        await commonErrorApi('post', `/auth/errorLog`, {
          errorName: err instanceof Error ? err.name : err,
          errorMessage: err instanceof Error ? err.message : err,
          errorFrom: from, // error 발생 함수
          service: 'ss-web',
          device: '',
        });
      } else {
        console.log('Error Log', err, 'from: ', from);
      }
    }
  };

  return { checkErrorLog };
};

export default useErrorLog;
